import { render, staticRenderFns } from "./chemBase.vue?vue&type=template&id=5d0ab4c6"
import script from "./chemBase.vue?vue&type=script&lang=js"
export * from "./chemBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0ab4c6')) {
      api.createRecord('5d0ab4c6', component.options)
    } else {
      api.reload('5d0ab4c6', component.options)
    }
    module.hot.accept("./chemBase.vue?vue&type=template&id=5d0ab4c6", function () {
      api.rerender('5d0ab4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chem/chemBase.vue"
export default component.exports